import React, {cloneElement, ReactNode, useContext, useEffect, useState} from "react";
import {useHistory} from "react-router";
import {Search} from "../../../filtering";
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import Select from '../../../ui/Select';
import PrimaryButton from '../../../ui/PrimaryButton';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import MoveTypeDropDown from '../../../uiControls/MoveTypeDropDown';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import {OceanExportHblPreview, SuntekSettings, SystemSettings} from "../../../ifmsTypes";
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import * as XCol from "../../../framework.core/XExportColumn";
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import ApplicationContext from "../../../ApplicationContext";
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import {JobNames} from "../../../framework.core/JobNames";
import {oceanExportHblList} from "../tableSettings";
import BlackInverseButton from "../../../ui/BlackInverseButton";
import IfmsModal from "../../../ui/IfmsModal";
import fastStorage from "../../../fastStorage";
import HblMilestonePopup from "./HblMilestonePopup";
import ListViewShortcutMenu from "../../common/ListViewShortcutMenu";
import {OeHblListItem, OehListType} from "../../../fms.data/models/OeHblListItem";
import {ReactComponent as ContainerTrackingIcon} from "../../../img/container_tracking.svg";
import ToolboxMenuItem from "../../../uiControls/ToolboxMenuItem";
import Menu, { IfmsMenuItem } from "../../../ui/menu/Menu";
import { FmsSubMenu } from "../../../constants/fmsSubMenu";
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from "../../../hooks/useReportViewer";
import loadInfoAreaInvoiceBillCrDb from "../../common/InfoAreaInvoiceBillCrDb";
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer, TrackEventNameRenderer } from "../../common/commonListRenderers";
import DeleteHistory from "../../reports/DeleteHistory";
import postal from 'postal';
import { getFmsGlobal } from "../../../globals";
import useSetEditedId from "../../../hooks/useSetEditedId";
import { FmsSecTask } from "../../../fms.core/constants";
import { findSecurityTask } from "../../../util";
import { useJournal } from "../../accounting/general/journal/JournalListView";
import useSuntekSettings from "../../../hooks/useSuntekSettings";
import PrimaryInverseButton from "../../../ui/PrimaryInverseButton";
import _ from "lodash";
import RecogModal from "../../../ui/RecogModal";
import constants from "../../../constants";
import { formatShipmentType } from "../../common/utils/formatUtils";
import { formatDateTime } from "../../../dateUtils";
import { Decimalformat } from "../../common/commonExportFormat";

// function IndicatorRenderer({value, data, row}: any) {
//   const jobListContext = useContext(JobListViewContext);
//   let content:React.ReactNode | null = null;

//   if(!value) {
//     content =  <span>D</span>;
//   }else{
//     content = <span>{value}</span>;
//   }

//   function onIndicatorClick() {
//     if (jobListContext.rowExtrasId) {
//       return; // Some row is already selected
//     }

//     jobListContext.setRowExtrasId(data[row.index].id);
//   }

//   return (
//     <div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
//   );
// }
function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

// function MblNoRenderer({data, row, value}: any) {
//   const {switchToMblFor} = useHblOperations();

//   return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
//     <div role='button' onClick={() => switchToMblFor(data[row.index])}>
//       {value}
//     </div>
//   </div>;
// }


function HblTypeFilterRenderer({value, onChange}: any) {
  return (
    <Select
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        {value: 'None', label: 'None'},
        {value: 'S', label: 'Standard'},
        {value: 'C', label: 'Co-Load'},
      ]}      
    />
  );
}

function MoveTypeFilterRenderer({value, onChange}: any) {
  return (
    <MoveTypeDropDown
    name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}
    />
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

// function AfterMemoLogButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as OeHblListItem;

//   return (
//     <>
//       &nbsp;&nbsp;
//       <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
//         onClick={() => window.open(`http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mblNo}`)}>
//         <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
//       </BlackInverseButton>
//     </>
//   )
// }

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OeHblListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.OEHbl, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function HblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);

  const { deleteHbl, edit, view, copy, viewBillings, moveToDeleteHistoryReport, setSavedEntityOem } =
    useSelectedHblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  
  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/view/${id}`);
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityOem(selectedElement.oeMblId?.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);
    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OEHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  const allowedStatuses = ['', 'E', 'D'];
  
  const listSec = findSecurityTask(appContext, FmsSecTask.OEHbl);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew()&& listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;


  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/oeMbl/oceanExport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/oceanExport/mbl/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
    ? `/oceanExport/hbl/add?mblRefId=${jobListContext.f6Query}`
    : '/oceanExport/hbl/add';
    

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='oeh-list-add-button' display="primary" size="regular" link={newUrl} disabled={!canBeAdd} label="New"/>&nbsp;
        <PrimaryButton name='oeh-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='oeh-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='oeh-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteHbl}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='oeh-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton size="regular" onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
        <PrimaryButton size='regular' onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.oeMblId} mTbName={"T_OOMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function HblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

/*function formatData(data: Array<OceanExportHblPreview>) {
  return data.map(d => ({
    ...d,f
    hblType: formatHblType(d.hblType),
    shipmentType: formatShipmentType(d.shipmentType ?? ''),
  }));
}*/

function useHblOperations() {
  const history = useHistory();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const jobListContext = useContext(JobListViewContext);

  function switchToMblFor(hbl: OceanExportHblPreview | null) {
    if (!hbl) {
      return;
    }

    if (hbl.oeMblId) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeMbl/oceanExport', 
      'id', 'Ref. #', hbl.oeMblId ?? 0, 'updated', false, true, null, 'refNo', hbl.refNo, false,true);
    }

    openNewPage(history, `/common/joblistview/oeMbl/oceanExport`, NavigationType.newPage);
  }

  function switchToBookingFor(hbl: OceanExportHblPreview | null) {
    if (!hbl) {
      return;
    }

    if (hbl.hblNo) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeBooking/oceanExport', 
      'hblNo', 'HBL #', hbl.hblNo, 'updated', false, true);
    }
    else if (hbl.hBookingNo) {
      jobListContext.setFilterForScreenExternally('/common/joblistview/oeBooking/oceanExport', 
      'hBookingNo', 'Booking #', hbl.hBookingNo, 'updated', false, true);
    }
    
    openNewPage(history, `/common/joblistview/oeBooking/oceanExport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(hbl:OeHblListItem|null) {
    if (!hbl) {
      return;
    }

    openNewPage(history, `/accounting/Acct/${JobNames.OEHbl}/${hbl.id}`, NavigationType.newPage);
  }
  return {switchToMblFor, switchToBookingFor, switchToAcctInfo};
}

function useSelectedHblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const {switchToMblFor, switchToBookingFor} = useHblOperations();

  const selectedElement = jobListContext.selectedElement as OeHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');
  
  const setSavedEntityOem = useSetEditedId([JobNames.OEMbl]);

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/hbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }
    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/oeMbl/oceanExport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/oceanExport/mbl/edit/' + jobListContext.f6Query;

    const newUrl = openedByF6 || openedByMaster
      ? `/oceanExport/hbl/add?mblRefId=${jobListContext.f6Query}`
      : '/oceanExport/hbl/add';

    openNewPage(history, newUrl, NavigationType.newPage);

  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close HBL first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OEHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OEHB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OEHbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
        setSavedEntityOem(selectedElement.oeMblId?.toString(), false);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }
    
    const id = selectedElement.id;
    const editUrl = `/oceanExport/hbl/edit/${id}`;
    const viewUrl = `/oceanExport/hbl/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/oceanExport/hbl/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }
    
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/oceanExport/viewBillings/hbl/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }
  
  async function moveToDeleteHistoryReport() {
    if (!selectedElement) return;

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OEHbl}&id=${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit: boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =  `/oceanExport/hbl/edit/${id}`;
    const viewUrl =  `/oceanExport/hbl/$view/${id}`;
    
    let editUrlProfitTab = `${editUrl}/5`;
    let viewUrlProfitTab = `${viewUrl}/5`;

    if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/oceanExport/hbl/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab, [viewUrl, editUrl]);
  }


  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanExport/hbl/edit/${id}`;
    const viewUrl = `/oceanExport/hbl/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.OEHbl);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/hbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/oceanExport/hbl/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as OceanExportHblPreview;
    switchToMblFor(selectedElement);
  }

  function switchToBooking() {
    const selectedElement = jobListContext.selectedElement as OceanExportHblPreview;
    switchToBookingFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return {
    create,
    deleteHbl,
    edit,
    view,
    copy,
    switchToMbl,
    switchToBooking,
    recognize,
    viewBillings,
    moveToDeleteHistoryReport,
    viewProfit,
    setSavedEntityOem,
  };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMbl, switchToBooking, recognize, viewBillings, viewProfit } = useSelectedHblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as any;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.OEHbl);
  const fmsGlobal = getFmsGlobal();

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OEHbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/hbl/edit/${selectedElement.id}`)) {
      const editModelKey = `editOeHbl${selectedElement.id}-/oceanExport/hbl/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Booking List', shortcut: 'F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to MBL List', shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    // { label: 'View B/L Activity Status', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];
  
  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="oeh-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        switchToBooking();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        switchToMbl();
        break;
      case 7:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 8:
        copy();
        break;
      case 9:
        viewBillings();
        break;
      case 10:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 11:
        processFileLock();
        break;
      case 12:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function HblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.OEHbl);

  const {copy, create, edit, view, switchToMbl, switchToBooking, viewBillings, viewProfit} = useSelectedHblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToMbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F4") {
      switchToBooking();
    } else if (unprocessedFkey === "CTRL+F2") {
      copy();
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `HBL #: ${(jobListContext.selectedElement as OeHblListItem|null)?.hblNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportHbl}
      jobName={JobNames.OEHbl}
      //entityId={(jobListContext.selectedElement as oceanExportHblPreview|null)?.id}
      jobId={(jobListContext.selectedElement as OceanExportHblPreview | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function formatData(data:Array<OeHblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

/**
 * Concrete implementation for HBL List screen
 *
 * @class HblListView
 * @extends {AbstractListView}
 */
class HblListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  oceanExportHblList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = OeHblListItem.getExportCollection(OehListType.Normal, useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'updated',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'hblType',
        renderer: HblTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;

    return OeHblListItem.getExportCollection(OehListType.Normal, useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if(x.dataIndex === "refNo") colRenderer.Cell = TextAlignLeftRenderer;
      else if(x.dataIndex === "amsBlNo") colRenderer.Cell = TextAlignLeftRenderer;
      else if (x.dataIndex === 'recognized') {
        colRenderer.Cell = RecognizedRenderer;
      }
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'shipperName' || x.dataIndex === 'consigneeName' || x.dataIndex === 'notifyName') colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if(x.dataIndex ==='lastEvent') colRenderer.Cell = TrackEventNameRenderer;
      else if (x.dataIndex === 'payStat') colRenderer.Cell = PaidRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if(x.dataIndex === 'kgs' )
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={systemSettings?.bl?.kgslbsDecimal ?? 0} />;
        else if(x.dataIndex === 'cbm' )
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={3} />;
          else
          colRenderer.Cell = FloatRenderer;
      }
      
      // debugger
      return colRenderer;
    });

  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    colRenderer.push({ accessor: 'cbm', changedValue: (value: any) => { return Decimalformat(value['cbm'],3) } });
    colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return Decimalformat(value['lbs'],2) } });
    colRenderer.push({ accessor: 'kgs', changedValue: (value: any) => { return Decimalformat(value['kgs'],2) } });
    colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
    colRenderer.push({ accessor: 'lastEvent', changedValue: (value: any) => { return (!!value['lastEvent'] ? value['lastEvent'] + ' ' + formatDateTime(value['lastEventDate']) : '') } });
    return colRenderer;
  }

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OEHbl,
      'OeHblListItem',
      OeHblListItem.calculateSearchParameters(search, OeHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }
    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  renderCommands(): ReactNode {
    return (
      <HblListCommands/>
    );
  }

  renderBeforeConfigureButton(): ReactNode {
    return (
      <HblListToolbar/>
    );
  }

  renderAfterConfigureButton(): ReactNode {
    return <></>
  }

  renderExtras(hideLogHistory: boolean): ReactNode {
    return <HblListViewExtras hideLogHistory={hideLogHistory} />
  }

  public renderInsideTopRightOpMenu(): React.ReactNode {
    return (
      <BlackInverseButton size="large" data-tooltip="Container Tracking" >
        <ContainerTrackingIcon width={20} height={20} />
      </BlackInverseButton>
    );
  }

  getViewUrlFor(row: OceanExportHblPreview) {
    return row && row.id ? `/oceanExport/hbl/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'HBL List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode|null {
    if (!rowId) {
      return null;
    }

    const storageKey = `oe-hbl-milestone-${rowId}`;

    function onClose() {
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="B/L Status" width="760px">
        <HblMilestonePopup hblId={rowId} storageKey={storageKey} onClose={onClose} isView={false} />
      </IfmsModal>
    );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OEHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    //#1607
    // return <AfterMemoLogButtonCommands />
    return null;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
  
  useLogHistory(): boolean {
    return true;
  }
};

export default HblListView;
